package pl.finn.forms.enums

enum class StyleClass(name: String, className: String) {
  FOOTNOTE("footnote", "f1"),
  HEADER("header", "h1"),
  NORMAL("normal", "n1");
}